// eslint-disable-next-line import/no-anonymous-default-export
export default (waypoints = [], setFields, setResultState, options, map) => {
  if (waypoints === '') return [];
  const keys = options.selectedPath.split('.');
  const key = keys[keys.length-1];
  return waypoints.map((value, index) => ({
    value: `${value.geometry.coordinates[1]},${value.geometry.coordinates[0]}`,
    draggable: false,
    iconX: 12,
    iconY: 14,
    onChange: ()=> {},
    onClick: ()=>{
      map.setCenter({lat: value.geometry.coordinates[1], lng: value.geometry.coordinates[0]}, true)
      setResultState({[key]: index})
    }
  }));
}
